import {DimensionOption, VehicleAddonResponseType} from "@CheckOrder/api/types/GetAddonDataQuery.type";
import {useTranslation} from "@Translation/hooks/useTranslation";

export default function useGetSelectedVehicleLengthLabel(
    activeOption: { value: number, label: string, activeGroup: VehicleAddonResponseType },
    additionalLength: DimensionOption | null
) {
    const {
        default: defaultLabel,
    } = useTranslation("check_order.addons.JADL.vehicle.additional_length")

    const getActiveLabel = () => {
        return activeOption.activeGroup.lengthOptions.find((option) => (
            option.value === additionalLength?.value
        ))?.label ?? defaultLabel
    }

    return {
        getActiveLabel,
    }
}